import { Component, OnInit } from '@angular/core';
import { RemoteService } from 'app/services/remote.service';
import { LocalStorageService } from 'ngx-store';
@Component({
  selector: 'app-my-portfolio-pro',
  templateUrl: './my-portfolio-pro.component.html',
  styleUrls: ['./my-portfolio-pro.component.scss']
})
export class MyPortfolioProComponent implements OnInit {

  constructor(private remoteService: RemoteService,
    private ls: LocalStorageService) { }

  ngOnInit() {
    try {
      //@ts-ignore
      $('.slider1').bxSlider({
        slideWidth: 200,
        minSlides: 2,
        maxSlides: 4,
        slideMargin: 10
      });
    } catch (e) { }
    if (this.ls.get('access_token')) {
      return this.remoteService.userNavigateTodashboard();
    }
    this.remoteService.scrollingtoNavbar();
  }

}
